export const initialState = {
  mySpecial: [],
  allSpecial: [],
  basketSpecialIds: [],
  auctionSpecial: [],
  auctionSpecialIds: [],
  dealDoneSpecial: [],
  wonSpecial: [],
  lostSpecial: [],
  editSpecial: undefined,
  specialDetails: undefined,
  specialDetailsId: '',
  customTime: undefined,
  timeStamp: undefined
};

export default function specialReducer(state = initialState, action) {
  switch (action.type) {
    case 'SPECIAL_FIND_ALLSPECIAL': {
      if (action.data) {
        const allSpecial = action.data.allSpecial;

        return {
          ...state,
          allSpecial: allSpecial
        };
      }
      return initialState;
    }
    case 'SPECIAL_SET_EDITSPECIAL': {
      if (action.data) {
        const editSpecial = action.data;

        return {
          ...state,
          editSpecial: editSpecial
        };
      }
      return initialState;
    }
    case 'SPECIAL_SET_SPECIALDETAILSID': {
      if (action.data) {
        const id = action.data;
        return {
          ...state,
          specialDetailsId: id
        };
      }
      return initialState;
    }
    default:
      return state;
  }
}
